export default {
  resource: {
    zh: {
      title:"角色",
      roleNo: "角色编号",
      roleName: "角色名称",
      nullNo:"请先输入角色编号！",
      nullName:"请先输入角色名称！",
      aExists:"角色编号或角色名称已经存在，请检查！",
      rights:"权限",
      remark:	"备注",
    }

  },
  delConf:["roleNo"],
  delKeys:["autoid", "roleNo"],
  buttons:[
    {key:"View", noRights:"true", class:"iconfont icon-view", singelCheck: true},
    {key:"Copy", rights:"Add", class:"iconfont icon-copy", singelCheck: true},
    {key:"Add", class:"iconfont icon-add"},
    {key:"Edit", class:"iconfont icon-edit1", singelCheck: true},
    {key:"Delete", class:"iconfont icon-custom-delete", singelCheck: true}
  ],
  params: {
    bmbh:{
      key: "roleNo",
      data: null,
      method: "Equal",
      type: "text"
    },
    bmmc:{
      key: "roleName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "roleNo","roleName","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "roleNo",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url:"role/"

}
